import type { LoaderFunctionArgs } from '@remix-run/node'
import { z } from 'zod'
import { zx } from 'zodix'
import { getChangelogEntry } from '~/services/contentful'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { renderOption } from '~/utils/contentful'
import { H1, H2, Stack } from '~/components-v2'
import { H1_LINE_HEIGHT } from '~/components-v2/text/types'
import { rudderStack } from '~/utils/rudder-stack.server'
import { typedjson, useTypedLoaderData } from 'remix-typedjson'
import { editorialDate } from '~/utils/date'

export { meta } from '~/utils'

export const loader = async ({ params, request }: LoaderFunctionArgs) => {
  const { slug } = zx.parseParams(params, { slug: z.string().optional() })
  const changelogEntry = await getChangelogEntry(slug)
  rudderStack(request, changelogEntry.title)
  return typedjson({
    ...changelogEntry,
    sectionTitle: 'Changelog',
    swiftypeSiteType: 'Changelog',
    title: editorialDate(changelogEntry.date),
    description: changelogEntry.title,
  })
}

export default function () {
  const { description, date, copy } = useTypedLoaderData<typeof loader>()
  return (
    <article>
      <Stack as="hgroup" padding="0,0,8" gap={2}>
        <H1
          lineHeight={H1_LINE_HEIGHT}
          fontSize="xxxl"
          wrap="balance"
          fontWeight={300}
        >
          {description}
        </H1>
        <H2 fontSize="md" color="text4">
          {editorialDate(date)}
        </H2>
      </Stack>
      <div className="editorial-copy">
        {documentToReactComponents(copy, renderOption)}
      </div>
    </article>
  )
}
